import { render, staticRenderFns } from "./RiskCreate.vue?vue&type=template&id=41de681f&scoped=true&"
import script from "./RiskCreate.vue?vue&type=script&lang=ts&"
export * from "./RiskCreate.vue?vue&type=script&lang=ts&"
import style0 from "./RiskCreate.vue?vue&type=style&index=0&id=41de681f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41de681f",
  null
  
)

export default component.exports